import { render } from "./testimonials-carousel.vue?vue&type=template&id=50ebe49f"
import script from "./testimonials-carousel.vue?vue&type=script&lang=js"
export * from "./testimonials-carousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__